import RoutesWeekQuery from './RoutesWeekQuery';
import { selectFromRoutePaginatedDto } from '../../models';

export default selectFromRoutePaginatedDto()
  .hasNextPage
  .edges(b => b.node(RoutesWeekQuery))
  .toString();
